export enum BulkUpdateAction {
  Resolve = 1,
  Close = 2,
  ChangeOwnerToClient = 3,
  ChangeOwnerToSO = 4,
  Update3rdPartyFields= 5,
}
